import { Box, styled } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { btLightOrange, hexToRgb, welcomeBlue, whiteColor } from '../../../assets/jss/nextjs-material-kit-pro';
import TrophyImg from '../../../assets/img/workbook_images/trophy.svg';

export const StyledBox = styled(Box)({
  display: 'inline',
  position: 'relative',
  zIndex: 200,
});

export const useWorkbookStyles = makeStyles((theme) => ({
  dividerGrid: {
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      marginLeft: 0,
    },
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '50px',
      marginLeft: '118px',
    },
  },
  topMargin: {
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: '45px',
    },
  },
  percentCompleteTitle: {
    fontWeight: 700,
    marginBottom: '15px',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '80%',
      fontSize: '1.875rem',
      lineHeight: '2.35rem',
      paddingLeft: '30px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      fontSize: '1.375rem',
      lineHeight: '1.55rem',
      paddingLeft: '10px',
    },
  },
  completionPercentage: {
    fontWeight: 700,
    color: whiteColor,
    paddingLeft: '190px',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    whiteSpace: 'nowrap',
    justifyContent: 'flex-start',
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      fontSize: '1.375rem',
      lineHeight: '1.55rem',
      paddingLeft: '20px',
      justifyContent: 'flex-start',
      textAlign: 'left',
    },
    [theme.breakpoints.up('sm')]: {
      width: '80%',
      fontSize: '1.875rem',
      lineHeight: '2.35rem',
    },
  },
  trophyBox: {
    WebkitMaskImage: (props) => `url(${TrophyImg})`,
    maskImage: (props) => `url(${TrophyImg})`,
    WebkitMaskSize: 'contain',
    maskSize: 'contain',
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    backgroundColor: (props) => (props.completed ? btLightOrange : whiteColor),
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      height: '70px',
      margin: '0 0 2px 2px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '65%',
      height: '50px',
      paddingLeft: '-10px',
    },
  },
  lineStyle: {
    borderTop: '0.00225rem dashed white',
    borderBottom: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    margin: '-5px 0 10px 0',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
    },
    [theme.breakpoints.up('md')]: {
      width: '94%',
    },
  },
  workbookTrophy: {
    backgroundColor: 'rgba(' + hexToRgb(welcomeBlue) + ', 0.40)',
    [theme.breakpoints.up('md')]: {
      width: '105%',
      margin: '40px 0 0 -20px',
      padding: '10px 0 10px 0',
    },
    [theme.breakpoints.down('md')]: {
      width: '120%',
      margin: '30px 0 -20px -100px',
      padding: '10px 0 10px -40%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '120%',
      margin: '20px 0 0px -20px',
      padding: '10px 0 20px 0',
    },
  },
  moveToFront: {
    position: 'relative',
    zIndex: 200,
  },
}));
